export const apiUrl =
	process.env.NODE_ENV === "development"
		? "http://localhost:8080"
		: "https://merchant-api.tastet.ca";
export const appUrl = process.env.NODE_ENV === "development" ?  `http://${window.location.host}`: `https://${window.location.host}`;
